import Button from 'components/Button'
import Control from 'components/Control/Control'
import Flex from 'components/Flex'
import React from 'react'
import RejectedIcon from '../../../../assets/icons/RejectedIcon'
import {
  Container,
  Content,
  Description,
  FlexWrapRole,
  Spacer,
  TopHeading,
} from '../../Style/style'
import { useNavigate } from 'react-router-dom'

const FailScreen = () => {
  const navigate = useNavigate()

  const FeedBackNavigation = () => {
    navigate(
      `/roles/viewRole/${params.CorpID}/${params.JobID}/questionnaire/feedback`
    )
  }
  //to block back button
  history.pushState(null, null, location.href)
  window.onpopstate = function () {
    history.go(1)
  }
  return (
    <Container alignCenter column center>
      <Content spaceBetween center column>
        <Flex column alignCenter>
          <FlexWrapRole center>
            <RejectedIcon />
          </FlexWrapRole>
          <Spacer />
          <TopHeading center alignCenter>
            Oops !! Something Went Wrong ...
          </TopHeading>
          <Description center mt={'6px'}>
            We appreciate your interest and wish you the best in your job
            search.
          </Description>
        </Flex>
        <Control width="100%" center top="20px">
          <Button.Secondary text="Go Back" onClick={FeedBackNavigation} />
        </Control>
      </Content>
    </Container>
  )
}

export default FailScreen
